import BonusProductionServices from "../../services/BonusProductionServices";
const state = {
    loadingBonusProduction: false,
    bonusProductionPending: [],
    bonusProductionPendingPdf: [],
    bonusProductionPendingExcel: [],
    bonusProductionLiquidation: [],
    bonusProductionPermissionApproveAndBill: false,
    bonusProductionSelected: [],
    bonusProductionPreliquidationPending: [],
    bonusProductionPdf: [],
    bonusProductionExcel: [],
    isBroker: false,
};
import { globalData } from "@/main";

const getters = {
    loadingBonusProduction: state => {
        return state.loadingBonusProduction;
    },
    bonusProductionPending: state => {
        return state.bonusProductionPending;
    },
    bonusProductionPendingPdf: state => {
        return state.bonusProductionPendingPdf;
    },
    bonusProductionPendingExcel: state => {
        return state.bonusProductionPendingExcel;
    },
    bonusProductionLiquidation: state => {
        return state.bonusProductionLiquidation;
    },
    bonusProductionPermissionApproveAndBill: state => {
        return state.bonusProductionPermissionApproveAndBill;
    },
    bonusProductionSelected: state => {
        return state.bonusProductionSelected;
    },
    bonusProductionPreliquidationPending: state => {
        return state.bonusProductionPreliquidationPending;
    },
    bonusProductionPdf: state => {
        return state.bonusProductionPdf;
    },
    bonusProductionExcel: state => {
        return state.bonusProductionExcel;
    },
    isBrokerBonusProduction: state => {
        return state.isBroker;
    },
};


const actions = {
    updateBonusProductionSelected(context, payload) {
        state.bonusProductionSelected = payload;
    },
    getBonusProductionLiquidation(context, payload) {
        context.commit("showLoadingBonusProductionIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusProductionServices.liquidation(payload, apsId)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusProductionLiquidation = [];
                    if (!globalData.validaSucursal) {
                        state.bonusProductionLiquidation = res.data.data
                    } else {
                        for (let i = 0; i < res.data.data.length; i++) {
                        if (!globalData.validaSucursal) {
                            params.agencyId = 0;
                            state.bonusProductionLiquidation.push(res.data.data[i]);
                        } else {
                            if (res.data.data[i].vtAgency.toUpperCase().trim() == agencyName.toUpperCase().trim()) {
                                state.bonusProductionLiquidation.push(res.data.data[i]);


                            }

                        }


                    }
                        
                    }
                    
                    
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProductionPendingPdf(context) {
        context.commit("showLoadingBonusProductionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusProductionServices.pendingPdf(apsUserName, apsId, agency)
            .then(res => {
                state.bonusProductionPendingPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProductionPendingExcel(context) {
        context.commit("showLoadingBonusProductionIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusProductionServices.pendingExcel(apsUserName, apsId, agency)
            .then(res => {
                state.bonusProductionPendingExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProductionPending(context, payload) {
        context.commit("showLoadingBonusProductionIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusProductionServices.pending(payload, apsId)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusProductionPending = [];
                    if (!globalData.validaSucursal) {
                        state.bonusProductionPending = res.data.data
                    } else {

                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].sucursal.toUpperCase().trim() == agencyName.toUpperCase().trim()) {
                                state.bonusProductionPending.push(res.data.data[i]);
                            }

                        }
                    }


                } else {
                    //Erro 100 no viene informacion
                    if (res.data.error == 100) {
                        state.bonusProductionPending = [];
                    } else {
                        context.commit("updateNotificationError", res.data.msg);
                    }

                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProductionPreliquidationPending(context, payload) {

        context.commit("showLoadingBonusProductionIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusProductionServices.preliquidation(payload, apsId, agency)
            .then(res => {
                state.bonusProductionPreliquidationPending = [];


                if (res.data.error == 0) {
                    if (!globalData.validaSucursal) {
                        state.bonusProductionPreliquidationPending = res.data.data
                    } else {

                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].vtAgency.toUpperCase().trim() == agencyName.toUpperCase().trim()) {
                                state.bonusProductionPreliquidationPending.push(res.data.data[i]);
                            }
                        }
                    }



                } else {
                    if (res.data.error != 100) {
                        context.commit("updateNotificationError", res.data.msg);
                    }

                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    bonusProductionPreliquidationValidatePermission(context) {
        const apsRuc = context.rootGetters.userProfile.identity;
        return BonusProductionServices.validatePermission(apsRuc)
            .then((res) => {
                if (res.data.error == 0) {
                    state.bonusProductionPermissionApproveAndBill = true;
                } else {
                    state.bonusProductionPermissionApproveAndBill = false;
                }
            })
            .catch(() => {
                state.permissionApproveAndBill = false;
            })
    },
    sendBonusProductionPreliquidationGeneration(context) {
        context.commit("showLoadingBonusProductionIndicator");
        const apsRuc = context.rootGetters.userProfile.identity;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusProductionServices.preliquidationGeneration(null, apsRuc, apsId, agency)
            .then(res => {

                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    sendBonusProductionPreliquidationApprove(context, preliquidation) {
        context.commit("showLoadingBonusProductionIndicator");
        let data = [preliquidation];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusProductionServices.preliquidationApprove(data, apsId, agency)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    sendBonusProductionPreliquidationApproveAndBill(context, idSelected) {
        context.commit("showLoadingBonusProductionIndicator");
        let ids;
        ids = [idSelected];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusProductionServices.preliquidationApproveAndBill(ids, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    sendBonusProductionPreliquidationReject(context, preliquidation) {
        let data = [preliquidation]
        context.commit("showLoadingBonusProductionIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusProductionServices.preliquidationReject(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProductionPdf(context, payload) {
        context.commit("showLoadingBonusProductionIndicator");
        return BonusProductionServices.bonusProductionPdf(payload)
            .then(res => {
                state.bonusProductionPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProduccionPreliminarPdf(context, payload) {
        context.commit("showLoadingBonusProductionIndicator");
        return BonusProductionServices.bonusPreliminarProductionPdf(payload)
            .then(res => {
                state.bonusProductionPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    getBonusProductionExcel(context, payload) {
        context.commit("showLoadingBonusProductionIndicator");
        return BonusProductionServices.bonusProductionExcel(payload)
            .then(res => {
                state.bonusProductionExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusProductionIndicator");
            });
    },
    validateIsUserAgentBonusProduction(context, userId) {
        return BonusProductionServices.IsUserAgent(userId)
            .then((respuesta) => {
                console.log(respuesta.data);
                context.commit("loadingAsBrokerBonusProduction", { isBroker: respuesta.data != null });
                state.isBroker = respuesta.data != null;
            })
            .catch(() => {
            })
            .finally(() => {
            });
    },
};

const mutations = {
    showLoadingBonusProductionIndicator(state) {
        state.loadingBonusProduction = true;
    },
    hideLoadingBonusProductionIndicator(state) {
        state.loadingBonusProduction = false;
    },
    loadingAsBrokerBonusProduction(state, { isBroker }) {
        state.isBroker = isBroker;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};